module.exports = __webpack_public_path__ + "media/img/corporate/story-5d39b0d8044ecc46f316feeeeefcedab.png";